import { Actions, UseFindTheLetterState } from './types';

export const initialState: UseFindTheLetterState = {
  pages: {},
  hint: {
    letterId: undefined,
    pageNumber: undefined,
  },
};

export const reducers = (state: UseFindTheLetterState, action: Actions): UseFindTheLetterState => {
  switch (action.type) {
    case 'SET_FOUND_LETTERS':
      return {
        ...state,
        pages: {
          ...state.pages,
          [action.payload.page]: {
            ...state.pages[action.payload.page],
            foundLetters: {
              ...state.pages[action.payload.page]?.foundLetters,
              [action.payload.foundLetter.letterId]: action.payload.foundLetter.value,
            },
          },
        },
      };
    case 'SET_HINT_LETTER':
      return {
        ...state,
        hint: { ...action.payload.hint },
      };
  }
};
